import {type FUNDING_SOURCE, type PayPalButtonsComponentOptions} from '@paypal/paypal-js';
import {FeatureFlag} from '../../../@type/features';
import {Feature} from '../features';
import {AbstractPayPalPayment} from './abstract/class-abstract-paypal-payment';

class PayPalPayLaterPayment extends AbstractPayPalPayment {
	public gatewayId() {
		return 'peachpay_paypal_paylater';
	}

	protected fundingType(): FUNDING_SOURCE {
		return 'paylater';
	}

	protected buttonStyle() {
		return Feature.metadata<PayPalButtonsComponentOptions['style']>(FeatureFlag.PAYPAL_PAYLATER_GATEWAY, 'button_style') ?? undefined;
	}
}

export {PayPalPayLaterPayment};
